import * as types from './navActionTypes.js';

export const setSmart = (smart) => ({ type: types.SET_SMART, smart: smart });
export const setShowActiveLines = (showActiveLines) => ({ type: types.SET_SHOWACTIVELINES, showActiveLines: showActiveLines });
export const setCurrentURL = (currentURL) => ({ type: types.SET_CURRENTURL, currentURL: currentURL });

